module.exports = __webpack_public_path__ + "img/bingo_ball-40.6170abed.png";